export default __webpack_public_path__ + "static/media/verbiage-excitement.372e1950.png";